export const NOT_AVAILABLE = 'N/A'
